import { fromTemplate } from '../../utils/dom.js';
import './footer.css';

export class Footer {
  render() {
    const year = new Date().getFullYear();
    const template = `
      <footer class="sl-footer" data-testid="site-footer">
        <div class="container sl-footer__bar">
          <p class="sl-footer__copy" data-testid="footer-copy">
            &copy; ${year} Striking Labs LLC. All rights reserved.
          </p>
          <p class="sl-footer__meta">strikinglabs.com</p>
        </div>
      </footer>
    `;
    return fromTemplate(template);
  }
}
